import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SelectField from './SelectField'
import TextField from './TextField'

const RoleLevel = () => {
  return (
    <Box width="full" gap="s24">
      <SelectField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.role.label')}
      />
      <SelectField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.level.label')}
      />
      <TextField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.job_title.label')}
        placeholder={i18n.t(
          'contract_versions.flows.fix.steps.role_level_salary.job_title.placeholder'
        )}
      />
      <TextField
        title={i18n.t('contract_versions.flows.fix.steps.role_level_salary.job_description.label')}
        placeholder={i18n.t(
          'contract_versions.flows.fix.steps.role_level_salary.job_description.placeholder'
        )}
      />
    </Box>
  )
}

export default RoleLevel
